import React__default from 'react';
import styled from 'styled-components';
import { Inline } from './Inline.js';
import { Stack } from './Stack.js';

const StyledStack = styled(Stack)`
  padding-inline-start: 2rem;
  display: flex;
  flex-direction: column;
  gap: ${(props)=>props.gap}rem;
  font-size: 1rem;
`;
/**
 * Layout component for creating an unordered list.
 *
 * @example
 * <BulletList gap={1}>
 *  <Bullet>An important point</Bullet>
 *  <Bullet>Another point</Bullet>
 * </BulletList>
 */ const BulletList = (props)=>{
    return React__default.createElement(StyledStack, {
        "data-hpy-web-bullet-list": "true",
        gap: props.gap !== undefined ? props.gap : 0.5,
        as: "ul"
    }, props.children);
};
BulletList.dataId = "data-hpy-web-bullet-list";
BulletList.displayName = "BulletList";
const Bullet = (props)=>{
    return React__default.createElement("li", {
        "data-hpy-web-bullet": "true"
    }, React__default.createElement(Inline, null, props.children));
};
Bullet.dataId = "data-hpy-web-bullet";
Bullet.displayName = "Bullet";

export { Bullet, BulletList };
